import React, { useState } from 'react';
import { useRouteMatch } from 'react-router';
import { Box, FiservCardInterface } from '@common-fe/common-fe';

import { CardActivationModal } from '../Cards/components/CardActivationModals/CardActivationModal';
import { ChangeStatusCardModal } from '../Cards/components/ChangeStatusCardModal/ChangeStatusCardModal';

import { CardCarousel } from './CardCarousel/CardCarousel';
import { CardDetailsHeader } from './CardDetailsHeader/CardDetailsHeader';
import { CardTransactionsList } from './CardTransactionsList/CardTransactionsList';
import CardDetailsShipment from './CardCarousel';
interface Props {
  isShipmentTrackerMode?: boolean;
}
export const CardDetails: React.FC<Props> = ({ isShipmentTrackerMode }) => {
  const {
    params: { id: employeeId },
  } = useRouteMatch<{ id: string }>();

  const [selectedCard, setSelectedCard] = useState<FiservCardInterface>();

  return (
    <Box data-testid="CardDetails-wrapper">
      <CardDetailsHeader
        isStandaloneMode={isShipmentTrackerMode}
        selectedCard={selectedCard}
      />
      {isShipmentTrackerMode ? (
        <CardDetailsShipment
          employeeId={employeeId}
          setSelectedCard={setSelectedCard}
        />
      ) : (
        <CardCarousel employeeId={employeeId} />
      )}

      <CardTransactionsList />
      <ChangeStatusCardModal />
      <CardActivationModal />
    </Box>
  );
};
